//线下接口
import axios, { testR } from "./common.js";
// import store from "../store/index";
import { Message } from "element-ui";
// import  from "./common";

/* export const offlinePost = function(){

} */

/**
 * 拼接请求地址
 * @param {string} end 需要拼接的url地址
 * @return {string} `v3/merchant/offlinestores/message/${merchant_id}?url=${end}`
 */
const pjUrl = function (end) {
  const merchant_id = localStorage.getItem("merchant_id");
  return `v3/merchant/offlinestores/message/${merchant_id}?url=${end}`;
};

/* const data = {
  merchant_id: localStorage.getItem("merchant_id"),
  url: "",
  access_token: localStorage.getItem("access_token"),
  token_type: localStorage.getItem("token_type"),
  branch_no: localStorage.getItem("branch_no")
    ? localStorage.getItem("branch_no")
    : "00"
}; */

/**
 * 插入商品（新建商品信息）
 * @param {*} info
 * @returns
 */
export const goodsInsertItem = function (info) {
  let datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    branch_no: localStorage.getItem("branch_no")
      ? localStorage.getItem("branch_no")
      : "00",
    items: []
  };
  datas.items.push({
    oper_no: localStorage.getItem("merchant_id"),
    ...info
  });
  return axios
    .post(pjUrl("dataserver/goods/insertitem"), JSON.stringify(datas))
    .catch(err => {
      Message.error(err);
    });
};

//TODO: 修改商品信息
/** 修改商品信息
 * @param {Object} obj
 */
// http://localhost:8080
export const modifyGoods = function (info, branch_no = "00") {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    method: "modify_goods",
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    branch_no: branch_no,
    items: []
  };
  for (let i in info) {
    var obj = {
      oper_no: localStorage.getItem("merchant_id"),
      ...info[i]
    };
    datas.items.push(obj);
  }

  return axios
    .post(pjUrl("DataServer/Goods/ModifyItem"), JSON.stringify(datas))
    .catch(err => {
      Message.error(err);
    });
};

//TODO: 要做
/**
 * 智能识别类别
 */
export const classifySmartDiscern = function (onlineclass) {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    online_classify_name: onlineclass
  };
  return axios
    .post(pjUrl("dataserver/classify/SmartDiscern"), JSON.stringify(datas))
    .catch(err => {
      Message.error(err);
    });
};

/**
 * 获取线下仓库号
 * @returns
 */
export const queryBranch = function () {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    value: {}
  };
  return new Promise((resolve, reject) => {
    axios
      .post(pjUrl("dataserver/common/GetBranchList"), JSON.stringify(datas))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      });
  });
};

//查类别
export const queryClassify = function () {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };
  return axios.post("dataserver/classify/queryclassify", JSON.stringify(datas));
};

//查供应商
export const querySupplier = function () {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };
  return axios.post("dataserver/supplier/querysupplier", JSON.stringify(datas));
};

//获取线下类别编码 /dataserver/classify/queryoffline
/* export const queryofflineClassify = function() {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    url: "/dataserver/supplier/querysupplier",
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };
  console.log("获取供应商：", datas);
  return axios.post(
    `/v3/merchant/offlinestores/message`,
    JSON.stringify(datas)
  );
}; */

//同步线上店铺号 /DataServer/supplier/sync
export const supplierSync = function (supplier_no, offline_supplier_no) {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    supplier_no,
    offline_supplier_no
  };
  return axios.post(pjUrl("DataServer/supplier/sync"), JSON.stringify(datas));
};
/**
 * 线下类别绑定
 * @param {string} classify_no 类别号
 * @param {string} offline_classify_no 线下类别号
 * @returns
 */
export const classifySync = function (classify_no, offline_classify_no) {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    classify_no,
    offline_classify_no
  };
  return axios.post(pjUrl("dataserver/classify/sync"), JSON.stringify(datas));
};
/**获取线下所有类别
 * @param {Object} value
 */
export const queryOfflineClassify = function () {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    method: "query_classify",
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };
  return new Promise((resolve, reject) => {
    axios
      .post(pjUrl("dataserver/classify/list"), JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          resolve(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

/**
 * /dataserver/classify/listbindingclassify
 * 获取线下所有类别的绑定情况
 * @returns
 */
export const classifyListbindingclassify = function () {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };

  return new Promise((resolve, reject) => {
    axios
      .post(
        pjUrl("dataserver/classify/listbindingclassify"),
        JSON.stringify(datas)
      )
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          resolve(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

/**
 * /DataServer/supplier/listbindingsupplier
 * 获取线下所有供应商绑定情况
 * @returns
 */
export const supplierlistbindingsupplier = function () {
  var datas = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };

  return new Promise((resolve, reject) => {
    axios
      .post(
        pjUrl("DataServer/supplier/listbindingsupplier"),
        JSON.stringify(datas)
      )
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          resolve(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

//新建线下商品
export const offlineInsertGoods = function (obj, branch_no) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    branch_no: branch_no,
    items: obj
  };
  return axios.post(pjUrl("dataserver/goods/insertitem"), JSON.stringify(data));
};

/**
 * 提交表单创建供应商
 * @param {"insheet"|"outsheet"} sheet in_sheet / out_sheet
 * @param {string} supno 供应商编号
 * @param {string} date  时间
 * @param {object[]} list  单据内容
 */
export const offlinecreateSheet = function (
  sheet,
  supno,
  sheet_no,
  list,
  branch_no
) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    method: sheet,
    access_token: localStorage.getItem("access_token"),
    sheet_no: sheet_no.slice(-10),
    token_type: localStorage.getItem("token_type"),
    branch_no: branch_no,
    supcust_no: supno,
    detail: list
  };
  // return $post(JSON.stringify(data));
  if (sheet === "insheet") {
    return axios.post(pjUrl("dataserver/sheet/InSheet"), JSON.stringify(data));
  } else if (sheet === "outsheet") {
    return axios.post(pjUrl("dataserver/sheet/OutSheet"), JSON.stringify(data));
  }
};

//获取最近一下交易的价格
//v3/merchant/chain/Transcation/sheet/LastTranscationPrice
/* export const sheetLastTranscationPrice = function(barcode,other_mch_no) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    url: "/dataserver/goods/insertitem",
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem('token_type'),
    mch_no:localStorage.getItem("merchant_id"),
    barcode,
    other_mch_no,
  }

  return axios.post(
    "/v3/merchant/offlinestores/message",JSON.stringify(data))
} */

/**模糊查询商品信息
 * @param {string} barcode 条码或名称
 */
export const offlineSearchGoodsInfo = function (
  barcode,
  accuracy = false,
  branch_no = "00"
) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    token_type: localStorage.getItem("token_type"),
    access_token: localStorage.getItem("access_token"),
    branch_no: branch_no === "" ? "00" : branch_no,
    barcode,
    accuracy
  };
  return axios.post(pjUrl("dataserver/goods/queryitem"), JSON.stringify(data));
};

//
/**
 * 批量查询商品信息
 * @param {string[]} items 商品条码 数组
 * @returns Promise
 */
export const offlineGoodsBatchQuery = function (items) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    token_type: localStorage.getItem("token_type"),
    access_token: localStorage.getItem("access_token"),
    branch_no: "00",
    items: items
  };
  return axios.post(pjUrl("DataServer/Goods/BatchQuery"), JSON.stringify(data));
};

/** 返回库存信息
 * @param {string} barcode 条码
 * @param {string} supno 供应商号
 */
export const offlineQueryStock = function (barcode, supno, branch_no = "00") {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    barcode: barcode,
    sup_no: supno,
    branch_no: branch_no
  };

  return new Promise((resolve, reject) => {
    axios
      .post(pjUrl("dataserver/Report/QueryStockNumber"), JSON.stringify(data))
      .then(res => {
        if (
          res.data.result_code === "SUCCESS" &&
          res.data.return_code === "SUCCESS"
        ) {
          resolve(res.data.resp_data[0].number);
        }
      });
  });
};

/** 获取供应商
 * @param {string} sup 供应商编号
 */
export const getSupcust = function (sup) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    value: sup
  };
  return new Promise((resolve, reject) => {
    axios
      .post(pjUrl("dataserver/supplier/list"), JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          resolve(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

/** 新建供应商
 *
 */
export const offlineGenerateSup = function (datas) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    ...datas
  };
  return axios.post(pjUrl("DataServer/supplier/create"), JSON.stringify(data));
};

/**
 * 新建类别
 */
export const offlineGenerateClass = function (datas) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    ...datas
  };
  return axios.post(pjUrl("dataserver/classify/create"), JSON.stringify(data));
};

/**
 * 获取所有线下会员
 * @returns 所有会员信息
 */
// /eMember/Baseinfo/list
export const offlineGetBaseInfoList = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };
  return new Promise((resolve, reject) => {
    axios
      .post(pjUrl("eMember/Baseinfo/list"), JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          resolve(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

/**
 *
 * @returns 所有会员信息
 */
// /eMember/Baseinfo/generate
export const offlineVipGenerate = function (
  membership,
  grade,
  branch_no = "00"
) {
  console.log("grade", grade);
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    branch_no,
    membership: {
      account_id: "",
      wx_union_id: "",
      sex: "",
      account_name: "",
      identity_card: "",
      grade: ""
    }
  };
  data.membership = { grade, ...membership };

  console.log(JSON.stringify(data));
  return axios.post(pjUrl("eMember/Baseinfo/generate"), JSON.stringify(data));
};

/**
 * 获取 线下卡类别
 * @returns
 */
export const offlineBaseinfoGradelist = function () {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type")
  };
  return new Promise((resolve, reject) => {
    axios
      .post(pjUrl("eMember/Baseinfo/gradelist"), JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          resolve(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};
